import { render, staticRenderFns } from "./PageJumpNavigation.vue?vue&type=template&id=c7e15872&scoped=true"
import script from "./PageJumpNavigation.vue?vue&type=script&lang=ts"
export * from "./PageJumpNavigation.vue?vue&type=script&lang=ts"
import style0 from "./PageJumpNavigation.vue?vue&type=style&index=0&id=c7e15872&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7e15872",
  null
  
)

export default component.exports